
import Img11 from '../src/assets/images/simple image/11.png'


const translations = {
  EN: {
    navItems: {
      home: 'Home',
      drop: 'Drop',
      shop: 'Shop',
      portfolio: 'Portfolio',
      blog: 'Blog',
    },
    cart: {
      title: 'Cart',
      empty: 'No products in the cart.',
    },
    favorite: {
      title: 'Favorite',
    },
    profile: {
      title: 'Profile',
    },
    search: {
      placeholder: 'Search',
    },

    slider: [
      {
        id: 1,
        image: Img11,
        title: 'Casual Look',
        text: 'Discover casual and stylish outfits for everyday wear.',
        link: 'https://example.com/casual-look',
      },
    ],

    navCart: {
      title: 'Cart', // متن مربوط به ناوبری
      empty: 'No products in the cart.', // متن مربوط به خالی بودن
    },

    navSearch: {
      placeholder: 'Search',
    },

    aboutSection: {
      text: "Always ask for the best from us, because you only get one chance to shop, and it won't happen again. You have the opportunity to stand out, as all available items are limited and produced only once.",
    },
  },
  FA: {
    navItems: {
      home: 'خانه',
      drop: 'دراپ',
      shop: 'فروشگاه',
      portfolio: 'نمونه کارها',
      blog: 'وبلاگ',
    },
    cart: {
      title: 'سبد خرید',
      empty: 'هیچ محصولی در سبد خرید نیست.',
    },
    favorite: {
      title: 'علاقه‌مندی‌ها',
    },
    profile: {
      title: 'پروفایل',
    },
    search: {
      placeholder: 'جستجو',
    },

    slider: [
      {
        id: 1,
        image: Img11,
        title: 'ظاهر روزمره',
        text: 'لباس‌های راحت و شیک برای استفاده روزانه را کشف کنید.',
        link: 'https://example.com/casual-look',
      },
    ],

    navCart: {
      title: 'سبد خرید', // متن مربوط به ناوبری
      empty: 'هیچ محصولی در سبد خرید نیست.', // متن مربوط به خالی بودن
    },

    navSearch: {
      placeholder: 'جستجو',
    },

    aboutSection: {
      text: 'همیشه بهترین ها را از ما بخواهید چون فقط یک بار شانس خرید دارید و دیگر تکرار نمیشود و فقط شما میتوانید خاص باشید چون همه آیتم های موجود محدود هستند و فقط یک بار تولید میشود',
    },
  },
}

export default translations
